import React from "react";
import styles from "./Menu.module.css";

const menuItems = {
  breakfast: [
    {
      name: "Classic English Breakfast",
      desc: "Eggs, bacon, sausage, baked beans, toast",
      price: "₦3,000",
    },
    {
      name: "Pancake stack",
      desc: "Fluffy pancakes with syrup, butter, and seasonal fruits",
      price: "₦2,200",
    },
    {
      name: "Avocado Toast",
      desc: "Sourdough bread, smashed avocado, poached egg",
      price: "₦2,500",
    },
  ],
  burgers: [
    {
      name: "Classic Beef Burger",
      desc: "100% beef patty, lettuce, tomato, cheese, and sauce",
      price: "₦4,000",
    },
    {
      name: "Spicy Chicken Burger",
      desc: "Fried chicken, jalapeños, spicy mayo",
      price: "₦3,800",
    },
    {
      name: "Veggie Burger",
      desc: "Black bean patty, avocado, tomato, lettuce",
      price: "₦3,500",
    },
  ],
  pizza: [
    {
      name: "Margherita",
      desc: "Tomato base, mozzarella, fresh basil",
      price: "₦4,500",
    },
    {
      name: "Pepperoni Deluxe",
      desc: "Double pepperoni, cheese blend",
      price: "₦5,200",
    },
    {
      name: "BBQ Chicken Pizza",
      desc: "Grilled chicken, onions, BBQ sauce",
      price: "₦5,000",
    },
  ],
};

const FoodSection = ({ title, items }) => (
  <div className={styles["menu-section"]}>
    <h3>{title}</h3>
    {items.map((item, index) => (
      <div className={styles["menu-item"]} key={index}>
        <div>
          <p className={styles["item-name"]}>{item.name}</p>
          <p className={styles["item-desc"]}>{item.desc}</p>
        </div>
        <p className={styles["item-price"]}>{item.price}</p>
      </div>
    ))}
  </div>
);

const FoodMenu = () => {
  return (
    <>
      {/* BLACK SECTION */}
      <div className={styles["menu-container"]}>
        <h2 className={styles["menu-title"]}>AURELIA FOOD MENU</h2>
        <p className={styles["menu-subtext-heading"]}>08042444922</p>
        <p className={styles["menu-subtext"]}>
          Please ensure to call the kitchen first to make sure your craved food
          item is available
        </p>

        <div className={styles["menu-columns"]}>
          <FoodSection title="BREAKFAST" items={menuItems.breakfast} />
          <FoodSection title="BURGERS" items={menuItems.burgers} />
          <FoodSection title="PIZZA" items={menuItems.pizza} />
        </div>
      </div>

      {/* WHITE SECTION */}
      <div className={styles["ingredients-container"]}>
        <h2 className={`${styles["menu-title"]} ${styles.black}`}>AURELIA INGREDIENTS MENU</h2>
        <p className={`${styles["menu-subtext"]} ${styles.dark}`}>
          This menu contains ingredients you may need for your personal cooking
        </p>

        <div className={styles["menu-columns"]}>
          <div>
            <FoodSection title="BREAKFAST" items={menuItems.breakfast} />
            <FoodSection title="BURGERS" items={menuItems.burgers} />
            <FoodSection title="PIZZA" items={menuItems.pizza} />
          </div>
          <div>
            <FoodSection title="BREAKFAST" items={menuItems.breakfast} />
            <FoodSection title="BURGERS" items={menuItems.burgers} />
            <FoodSection title="PIZZA" items={menuItems.pizza} />
          </div>
        </div>
      </div>
    </>
  );
};

export default FoodMenu;
